export default __webpack_public_path__ + "static/media/tissueKnives.1286e7ad.png";